import { render, staticRenderFns } from "./BonitaOfApplicants.vue?vue&type=template&id=58e813dd&scoped=true&"
import script from "./BonitaOfApplicants.vue?vue&type=script&lang=js&"
export * from "./BonitaOfApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e813dd",
  null
  
)

export default component.exports